import PortfolioHeader from "./PortfolioHeader";
import PortfolioBody from "./PortfolioBody";


const Portfolio = () => (
    <>
        <PortfolioHeader />
        <PortfolioBody />
    </>
);

export default Portfolio;